










import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { PageBlockMixin } from '@/modules/cms';
import { WysiwygTwoColumnBlockDataFragment } from '@/graphql/generated';

@Component({
  graphqlData: gql`
    fragment WysiwygTwoColumnBlockData on WysiwygTwoColumnBlock {
      id
      contentLeft
      contentRight
      ...BlockColor
    }

    ${blockableBlockColorFragment}
  `,
})
export default class WysiwygTwoColumnBlock extends mixins(PageBlockMixin<WysiwygTwoColumnBlockDataFragment>(), blockColorMixin) {
  get backgroundColorClass () {
    if (!this.blockColor)
      return null;

    return `bg-${this.blockColor}`;
  }
}
